import React from 'react';
import CategoryDropdown from '../CategoryDropdown/CategoryDropdown';
import './ProductTable.css';

const ProductTable = ({ products, categories, onProductChange, onDeleteProduct }) => {
  const handleFieldChange = (index, field, value) => {
    const updatedProducts = [...products];
    if (field === 'price') {
      updatedProducts[index][field] = parseInt(value) || 0;
    } else {
      updatedProducts[index][field] = value;
    }
    onProductChange(updatedProducts);
  };

  const handleCategoryChange = (index, category) => {
    const updatedProducts = [...products];
    updatedProducts[index].category = category;
    onProductChange(updatedProducts);
  };

  if (!products || products.length === 0) {
    return (
      <div className="product-table-empty">
        <p>Chưa có sản phẩm. Vui lòng dán CSV ở phía trên.</p>
      </div>
    );
  }

  return (
    <div className="product-table-wrapper">
      <table className="product-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Tên sản phẩm</th>
            <th>Giá (VND)</th>
            <th>Link ưu đãi</th>
            <th>Danh mục</th>
            <th>Link sản phẩm</th>
            <th>Ảnh</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr key={index} className="product-row">
              <td className="index-cell">{index + 1}</td>
              <td>
                <input
                  type="text"
                  value={product.product}
                  onChange={(e) => handleFieldChange(index, 'product', e.target.value)}
                  className="input-field"
                  placeholder="Tên sản phẩm"
                />
              </td>
              <td>
                <input
                  type="number"
                  value={product.price}
                  onChange={(e) => handleFieldChange(index, 'price', e.target.value)}
                  className="input-field"
                  placeholder="0"
                />
              </td>
              <td>
                <input
                  type="url"
                  value={product.url}
                  onChange={(e) => handleFieldChange(index, 'url', e.target.value)}
                  className="input-field"
                  placeholder="https://..."
                />
              </td>
              <td>
                <CategoryDropdown
                  categories={categories}
                  value={product.category}
                  onChange={(category) => handleCategoryChange(index, category)}
                />
              </td>
              <td>
                <a
                  href={product.productLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-link-product"
                  title={product.productLink}
                >
                  Xem SP
                </a>
              </td>
              <td>
                <input
                  type="url"
                  value={product.img}
                  onChange={(e) => handleFieldChange(index, 'img', e.target.value)}
                  className="input-field"
                  placeholder="https://..."
                />
              </td>
              <td>
                <button
                  onClick={() => onDeleteProduct(index)}
                  className="btn-delete"
                  title="Xóa sản phẩm"
                >
                  Xóa
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
